<p *ngIf="hint === 'drillDownValueDoesNotExist'" [translate]="'message.validation_error.drill_down_value_does_not_exist'"></p>
<p *ngIf="hint === 'drillDownMultiValues'" [translate]="'message.validation_error.drill_down_value_multi_values'"></p>
